export default "__VITE_ASSET__d8a116cc__"